module.exports = __webpack_public_path__ + "static/media/directions_subway.95c65bd0.svg";